import ReactPaginate from 'react-paginate'
import classNames from 'classnames'
import { withI18next } from '../../../lib/withI18next'

const Pagination = props => (
  <ReactPaginate
    previousLabel={props.t('previous')}
    nextLabel={props.t('next')}
    pageRangeDisplayed={2}
    marginPagesDisplayed={2}
    pageCount={props.pageCount}
    onPageChange={props.onPageChange}
    initialPage={props.initialPage}
    breakLabel={'...'}
    breakClassName={"break-me"}
    containerClassName={classNames({
      "ma-pagination pagination is-centered": true,
      "is-invisible": !props.pageCount,
      "is-small": props.isSmall,
      [props.className]: props.className
    })}
    subContainerClassName={"pages pagination-list"}
    previousClassName={"pagination-previous"}
    nextClassName={"pagination-next"}
    pageClassName={"pagination-link"}
    pageLinkClassName={"pagination-link-inner"}
    activeClassName={"is-current"}
  />
)

export default withI18next('common')(Pagination)



// WEBPACK FOOTER //
// ./components/uiLib/Pagination/index.js